"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_snakecase_1 = __importDefault(require("lodash.snakecase"));
const query_string_1 = __importDefault(require("query-string"));
// ?is_all_ages=yes&is_senior=yes&max_price=100000&model_type_id%5B%5D=3&model_type_id%5B%5D=4&model_type_id%5B%5D=5&sort=newest-listings&view_type=list
const queryBuilder = (params) => {
    const query = Object.assign({}, params);
    return query_string_1.default
        .stringify(Object.keys(query)
        .filter((k) => typeof query[k] !== undefined)
        .filter((k) => query[k] !== "")
        .filter((k) => k !== "homeTypeId")
        .reduce((p, k) => Object.assign({}, p, { [(0, lodash_snakecase_1.default)(k)]: query[k] }), {}))
        .replace("location", "display_location")
        .replace(/age_restriction_type/g, "age_restriction_type%5B%5D")
        .replace(/num_bathrooms/g, "num_bathrooms%5B%5D")
        .replace(/num_bedrooms/g, "num_bedrooms%5B%5D")
        .replace(/seller_type_ids/g, "seller_type_id%5B%5D")
        .replace(/model_type_ids/g, "model_type_id%5B%5D")
        .replace(/listing_type_ids/g, "listing_type_id%5B%5D")
        .replace(/location_status_id/g, "location_status_id%5B%5D");
};
exports.default = queryBuilder;
